import React from 'react';
import { Layout, Row, Col } from 'antd';
import { FacebookFilled, InstagramFilled, YoutubeFilled } from '@ant-design/icons';
import './css/FooterSection.css';

const { Footer } = Layout;

const FooterSection = () => (
  <Footer className="footer-section">
    <div className="page-container">
      <Row gutter={[24, 24]}>
        <Col xs={24} md={8}>
          <h3>Contato</h3>
          <p>Rua Miguel Francisco Sobrinho, Qd C, Lotes 18 a 20</p>
          <p>Parque dos Pomares, Caldas Novas, Goiás</p>
          <p>Tel: (64) 3453-3326 / 99924-2002</p>
          <p>secretaria.adcn@hotmail.com</p>
          <p>tesouraria.adcn@hotmail.com</p>
          <p>midia.adcn@hotmail.com</p>
        </Col>
        <Col xs={24} md={8}>
          <h3>Administrativo</h3>
          <p>Atendimento:</p>
          <p>Segunda a Sexta</p>
          <p>Das 9h às 18h</p>
        </Col>
        <Col xs={24} md={8}>
          <h3>Siga-nos</h3>
          <div className="social-icons">
            <a href="#" target="_blank" rel="noreferrer"><FacebookFilled /></a>
            <a href="#" target="_blank" rel="noreferrer"><InstagramFilled /></a>
            <a href="#" target="_blank" rel="noreferrer"><YoutubeFilled /></a>
          </div>
        </Col>
      </Row>
    </div>
  </Footer>
);

export default FooterSection;
